// ============================================================
// EMME SERVICE CAR — FILE DI CONFIGURAZIONE CENTRALE
// Modifica qui tutti i dati aziendali, i testi e le immagini.
// I valori tra [PARENTESI] sono PLACEHOLDER da sostituire.
// ============================================================

export const company = {
  name: "EMME SERVICE CAR",
  // --- CONTATTI ---
  phoneDisplay: "+39 340 618 3821",
  phoneHref: "tel:+393406183821",
  whatsapp: "393406183821",
  email: "emmeservicecar@pec.it",
  address: "Via Galvani, 26 - 07026 Olbia (SS)",
  hours: "H24 · 7/7",
  isOpen24: true,
  vat: "02933640902",
  googleBusiness: "https://www.google.com/maps/search/?api=1&query=EMME+SERVICE+CAR+Olbia", // sostituire con il link diretto della scheda Google Business
  social: {
    facebook: "#", // [INSERIRE LINK]
    instagram: "#", // [INSERIRE LINK]
  },
  // --- AREA OPERATIVA ---
  areaShort: "Olbia · Gallura · Costa Smeralda",
  areaFull: "Olbia, Gallura, Costa Smeralda e Sardegna",
  localities: [
    "Olbia", "Golfo Aranci", "Arzachena", "Porto Cervo", "San Teodoro",
    "Budoni", "Palau", "Santa Teresa Gallura", "Tempio Pausania",
    "Nuoro", "Sassari", "Cagliari",
  ],
  locality: "Olbia",
};

export const images = {
  hero: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/80906174b7f3406d2b74f217e86c535c7585d012b58f29a63ac29d6854f49ec3.jpeg",
  carRecovery: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/e44839f8675ccc3def1d448b36ca457df159fc0d3e1c7e0f7eb4ad5257318bfd.jpeg",
  moto: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/808903cfcedad5766c35ae074122991dfa86b6a90912605ba8c539db3a6464ca.jpeg",
  camper: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/b3a07bf46ce58fcba36245dddd6bd1ce67177e2dbd3df3408e8b96aa5b6bc48e.jpeg",
  tractor: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/ffe3ca9b15e034fe74526433b54862430f3d9cbd249a0edb9631bc565fb4c369.jpeg",
  excavator: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/0f029058d47f478926e7fe6af9b5254595aad7b209322c2703cb77463ed3a14c.jpeg",
  human: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/f46a90ac066a708dea990d206a5ed9350ec6111eb72fd36bb3769e550e3d82eb.jpeg",
  fleet: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/aef07a7eb58dbc5e8fd1681fb6a47f945da9890a605b85675c6bf3f333c453c3.jpeg",
  cta: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/3dc2a1f38fb0eade8aa9f911e4768b53b5fb182366fd75323e36ba8fe6c74493.jpeg",
  operator: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/40e5da7d148582ab86d06b079fac9de856f1b1a53cab5ae559fb4d941607e86e.jpeg",
  serviceTransport: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/a561ae1f8a1bdef37ca568d345639dc184bad3bbe39b874ce2a8eb84b2775577.jpeg",
  serviceScrap: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/d7e5405c9f2e415a5f718d547ab682dc219fea5e66b3337d6c2f4309c2415c3f.jpeg",
  rentalCar: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/d5a9dfed3a8f579e02146bd93ee90f29ddec22578f5d1339b070afd5e6151911.jpeg",
  saleCar: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/ee158cdd0322e3ebae61ad9e7632bf510096fb6fa0a30d99ff12a1285b11f562.jpeg",
  // --- Carroattrezzi REALE EMME SERVICE CAR (Iveco Eurocargo giallo) ---
  truckReal1: "https://customer-assets-m6fa6gv7.emergentagent.net/job_emme-rescue-hub/artifacts/odctj13d_WhatsApp%20Image%202026-08-19%20at%2020.21.03.jpeg",
  truckReal2: "https://customer-assets-m6fa6gv7.emergentagent.net/job_emme-rescue-hub/artifacts/ybtt4bup_WhatsApp%20Image%202026-08-19%20at%2020.23.14.jpeg",
  // --- Fac-simile coerenti (stesso mezzo giallo) ---
  heroReal: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/b06fadb2e6dbd9adc5f805a24fb6888514e3847e2ce08ecbafb1cfcef556e9dd.jpeg",
  recoveryReal: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/aa7d8f0910366253d5a6c55184c1c70ad11e7ef0060ea003e11d1aa3c1437eea.jpeg",
  transportReal: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/a70f775ed083e6943cc35d7627d7acbfc449ce99ff6591fa82f59b8074daeb81.jpeg",
  camperReal: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/0ef7228cf4aa13e943b34554fae8bc2b75916f6c1a2c6b1d090fbdc01e308ef7.jpeg",
  vanReal: "https://static.prod-images.emergentagent.com/jobs/aff99dda-a125-4807-b20d-a529a783d096/images/3aa4b816ec01de0ab839b3891eb38d23a7b1b7b953141f6853275f5006824aff.jpeg",
};

// Servizi — 6 categorie consolidate, ordine definitivo. Icone lucide-react, immagine, ancora URL, testi bilingue.
// action: "assistance" | "transport" | "ritiro" -> WhatsApp contestuale; "quote" -> modulo trasporto programmato (#preventivo)
export const services = [
  {
    id: "rimorchio-auto", icon: "Car", image: images.recoveryReal, action: "assistance",
    it: { title: "Rimorchio auto", desc: "Recupero e trasporto di automobili guaste, incidentate o non marcianti.", cta: "RICHIEDI ASSISTENZA" },
    en: { title: "Car towing", desc: "Recovery and transport of broken-down, crashed or non-running cars.", cta: "REQUEST ASSISTANCE" },
  },
  {
    id: "rimorchio-moto", icon: "Bike", image: images.moto, action: "assistance",
    it: { title: "Rimorchio motociclette", desc: "Recupero e trasporto di moto e scooter con sistemi di carico e fissaggio adeguati.", cta: "RICHIEDI ASSISTENZA" },
    en: { title: "Motorcycle towing", desc: "Recovery and transport of motorcycles and scooters with proper loading and tie-down systems.", cta: "REQUEST ASSISTANCE" },
  },
  {
    id: "trasporto-locale-lunga-distanza", icon: "Route", image: images.transportReal, action: "quote",
    it: { title: "Trasporto Locale e di Lunga Distanza", desc: "Trasporto programmato di veicoli su tratte locali e lunga distanza.", note: "Per privati, aziende, officine, carrozzerie e concessionarie.", cta: "RICHIEDI TRASPORTO" },
    en: { title: "Local & long-distance transport", desc: "Scheduled vehicle transport on local routes and long distances.", note: "For private customers, companies, garages, body shops and dealerships.", cta: "REQUEST TRANSPORT" },
  },
  {
    id: "camper-roulotte", icon: "Caravan", image: images.camperReal, action: "transport",
    it: { title: "Roulotte e camper", desc: "Assistenza e trasporto di camper, caravan e roulotte.", cta: "RICHIEDI TRASPORTO" },
    en: { title: "Campers & caravans", desc: "Assistance and transport of motorhomes, campers and caravans.", cta: "REQUEST TRANSPORT" },
  },
  {
    id: "macchine-operatrici-agricoli", icon: "Tractor", image: images.excavator, action: "transport",
    it: { title: "Macchine operatrici e mezzi agricoli", badge: "Trasporto con pianale", desc: "Trasporto con pianale di trattori, escavatori, macchine operatrici e mezzi agricoli.", note: "Servizio soggetto a verifica di peso e dimensioni del mezzo.", cta: "RICHIEDI TRASPORTO" },
    en: { title: "Work & agricultural machinery", badge: "Flatbed transport", desc: "Flatbed transport of tractors, excavators, work machinery and agricultural vehicles.", note: "Service subject to verification of the vehicle's weight and dimensions.", cta: "REQUEST TRANSPORT" },
  },
  {
    id: "rottamazione", icon: "Recycle", image: images.serviceScrap, action: "ritiro",
    it: { title: "Rottamazione veicoli", desc: "Ritiro e trasporto di veicoli destinati alla demolizione.", note: "Trasferimento verso strutture autorizzate secondo le procedure previste.", cta: "RICHIEDI IL RITIRO" },
    en: { title: "Vehicle scrapping", desc: "Collection and transport of end-of-life vehicles.", note: "Transfer to authorised facilities according to applicable procedures.", cta: "REQUEST PICKUP" },
  },
];

export const translations = {
  it: {
    lang: "it",
    nav: { home: "Home", services: "Servizi", company: "Azienda e flotta", contact: "Contatti", assistNow: "ASSISTENZA ORA" },
    common: {
      callNow: "CHIAMA ORA", call: "CHIAMA", callFull: "CHIAMA SUBITO", whatsapp: "SCRIVI SU WHATSAPP",
      whatsappShort: "WHATSAPP", sendLocation: "INVIA LA MIA POSIZIONE", location: "POSIZIONE",
      requestQuote: "RICHIEDI PREVENTIVO", requestTransport: "RICHIEDI TRASPORTO", discover: "SCOPRI IL SERVIZIO",
      operativeNow: "Operativi ora", callEmme: "CHIAMA EMME SERVICE CAR", checkAvailability: "VERIFICA DISPONIBILITÀ",
      readAllReviews: "Leggi le recensioni su Google", next: "Avanti", back: "Indietro", send: "Invia richiesta",
    },
    hero: {
      overline: "SOCCORSO E TRASPORTO VEICOLI",
      titleL1: "QUANDO TI FERMI,", titleL2: "NOI CI MUOVIAMO.",
      subtitle: "Soccorso stradale e trasporto con pianale di auto, moto, camper, mezzi agricoli e veicoli speciali.",
      question: "DI COSA HAI BISOGNO?",
      optNow: "SONO FERMO ADESSO", optSchedule: "DEVO ORGANIZZARE UN TRASPORTO",
      nowHint: "Comunica posizione, tipo di veicolo e problema.",
      scheduleHint: "Ti aiutiamo a organizzare un trasporto programmato con un preventivo chiaro.",
    },
    trust: {
      title: "PERCHÉ SCEGLIERE EMME SERVICE CAR",
      items: [
        { t: "Assistenza professionale", d: "Operatori preparati e comunicazione chiara in ogni fase." },
        { t: "Trasporto assicurato", d: "Copertura assicurativa del veicolo durante il trasporto sul carroattrezzi, secondo le condizioni previste dalla polizza." },
        { t: "Mezzi per ogni trasporto", d: "Configurazioni adatte a differenti tipologie di veicolo." },
        { t: "Locale e lunga distanza", d: "Spostamenti brevi e lunghe percorrenze verso la destinazione concordata." },
      ],
    },
    services: { overline: "COSA FACCIAMO", title: "COME POSSIAMO AIUTARTI", subtitle: "Un'unica realtà per soccorso, recupero e trasporto di ogni tipo di veicolo." },
    timeline: {
      overline: "IL METODO", title: "DALLA CHIAMATA AL RECUPERO",
      steps: [
        { n: "01", t: "CI CONTATTI", d: "Chiamaci oppure inviaci posizione e informazioni su WhatsApp." },
        { n: "02", t: "VALUTIAMO L'INTERVENTO", d: "Identifichiamo veicolo, problema, posizione e mezzo necessario." },
        { n: "03", t: "RAGGIUNGIAMO LA POSIZIONE", d: "Ti aggiorniamo sull'intervento e raggiungiamo il punto concordato." },
        { n: "04", t: "RECUPERIAMO E TRASPORTIAMO", d: "Mettiamo in sicurezza il veicolo e lo trasportiamo alla destinazione concordata." },
      ],
    },
    fleet: {
      overline: "LA FLOTTA", title: "IL MEZZO GIUSTO PER OGNI TRASPORTO",
      subtitle: "Le fotografie reali dei mezzi EMME SERVICE CAR verranno inserite qui. Placeholder chiaramente sostituibili.",
      cards: [
        { t: "Soccorso Stradale Auto Sportive", d: "Configurazione a pianale per carico completo e sicuro del veicolo.", use: "Auto sportive e vetture di pregio" },
        { t: "Soccorso Per Trasporti Pesanti", d: "Per mezzi agricoli e macchine operatrici.", use: "Trattori, escavatori, attrezzature" },
      ],
      note: "Portate, dimensioni e configurazioni verranno indicate solo quando verificate.",
    },
    human: {
      titleL1: "NON TRASPORTIAMO SOLTANTO,", titleL2: "MA CI PRENDIAMO CURA DEL TUO VEICOLO!",
      text: "Un guasto o un incidente può creare stress e incertezza. Per questo lavoriamo con comunicazione chiara, attenzione al veicolo e rispetto per il cliente.",
    },
    quote: {
      overline: "PREVENTIVO ONLINE", title: "ORGANIZZA IL TUO TRASPORTO",
      subtitle: "Pochi passaggi. Nessun account. Ti ricontattiamo con le condizioni.",
      s1: "Che cosa dobbiamo trasportare?", s2: "Da dove a dove?", s3: "Quando?", s4: "Come possiamo ricontattarti?",
      vehicles: ["Auto", "Moto", "Camper o roulotte", "Trattore Agricolo", "Macchina operatrice", "Altro"],
      origin: "Località di partenza", destination: "Località di destinazione",
      timings: ["Prima data disponibile", "Data specifica", "Urgente"],
      name: "Nome", phone: "Telefono", emailOpt: "Email (facoltativa)", notes: "Note",
      condition: "Condizioni del veicolo", canLoad: "Puoi caricarlo autonomamente?",
      yes: "Sì", no: "No", summary: "Riepilogo richiesta",
      privacy: "Ho letto e accetto l'informativa sulla privacy.",
      openWhatsapp: "Apri riepilogo su WhatsApp",
      note: "Il preventivo definitivo dipenderà da percorso, veicolo, condizioni di carico e mezzo necessario.",
      success: "Richiesta ricevuta. Ti ricontatteremo utilizzando il recapito indicato.",
      errPhone: "Inserisci un numero al quale possiamo contattarti.",
      errRequired: "Compila i campi obbligatori per continuare.",
      errPrivacy: "Per inviare la richiesta è necessario accettare l'informativa privacy.",
    },
    reviews: {
      overline: "RECENSIONI", title: "LA FIDUCIA SI COSTRUISCE SULLA STRADA.",
      placeholder: "Le recensioni Google reali verranno mostrate qui una volta collegata la scheda Google Business verificata. Non pubblichiamo recensioni inventate.",
    },
    map: {
      overline: "AREA OPERATIVA", title: "DOVE INTERVENIAMO",
      subtitle: "Interveniamo in Olbia, Gallura e Costa Smeralda, con trasporti programmati in tutta la Sardegna e sul territorio nazionale.",
      hq: "Sede operativa",
    },
    faq: {
      overline: "DOMANDE FREQUENTI", title: "QUELLO CHE C'È DA SAPERE",
      items: [
        { q: "Quali veicoli potete trasportare?", a: "Auto, moto, camper e roulotte, trattori, escavatori, macchine operatrici e veicoli speciali, in base alla portata dei mezzi disponibili." },
        { q: "Offrite soccorso stradale urgente?", a: "Sì. Puoi chiamarci direttamente oppure inviarci la tua posizione su WhatsApp per un intervento rapido." },
        { q: "Posso inviare direttamente la mia posizione?", a: "Sì. Con il pulsante 'Invia la mia posizione' condividi le coordinate GPS via WhatsApp in pochi secondi." },
        { q: "Effettuate trasporti a lunga distanza?", a: "Sì, organizziamo trasferimenti programmati verso destinazioni regionali e nazionali." },
        { q: "Trasportate motociclette?", a: "Sì, con sistemi di fissaggio adeguati per un trasporto sicuro di moto e scooter." },
        { q: "Trasportate camper e roulotte?", a: "Sì, ci occupiamo di trasferimento e assistenza di camper, caravan e roulotte." },
        { q: "Potete trasportare trattori o macchine operatrici?", a: "Sì, compatibilmente con portata e dimensioni dei mezzi disponibili." },
        { q: "Come viene calcolato il preventivo?", a: "Dipende da percorso, tipo di veicolo, condizioni di carico e mezzo necessario. Ti comunichiamo le condizioni prima dell'intervento." },
        { q: "Posso richiedere un trasporto programmato?", a: "Sì, tramite il modulo preventivo online oppure contattandoci direttamente." },
        { q: "Vi occupate del ritiro dei veicoli da rottamare?", a: "Sì, ritiriamo il veicolo destinato alla demolizione e lo gestiamo secondo le procedure previste." },
        { q: "Quali informazioni devo comunicare durante la chiamata?", a: "Posizione, tipo di veicolo, problema, destinazione ed eventuale presenza di persone o animali a bordo." },
        { q: "Posso contattarvi tramite WhatsApp?", a: "Certo. WhatsApp è il modo più rapido per inviarci posizione, foto e dettagli dell'intervento." },
      ],
    },
    finalCta: {
      titleL1: "SEI FERMO?", titleL2: "NON PERDERE TEMPO A CERCARE.",
      text: "Chiamaci oppure inviaci la posizione. Ti diremo subito quali informazioni servono per organizzare l'intervento.",
      note: "Per i trasporti programmati puoi richiedere un preventivo online.",
    },
    footer: {
      desc: "EMME SERVICE CAR offre servizi di soccorso stradale, recupero e trasporto di veicoli per privati, aziende e professionisti.",
      contacts: "Contatti", pages: "Pagine", area: "Area operativa", hours: "Orari",
      privacy: "Privacy Policy", cookie: "Cookie Policy", rights: "Tutti i diritti riservati.",
    },
    contact: {
      overline: "CONTATTI", title: "PARLA CON EMME SERVICE CAR",
      prepareTitle: "Quando ci contatti, prepara queste informazioni:",
      prepare: ["Posizione", "Tipo di veicolo", "Problema", "Destinazione", "Persone o animali a bordo"],
      phone: "Telefono", email: "Email", address: "Indirizzo", hours: "Orari", area: "Area operativa",
    },
    servicesPage: {
      overline: "I NOSTRI SERVIZI", title: "SOCCORSO, RECUPERO E TRASPORTO",
      subtitle: "Sei servizi chiari per privati, aziende e professionisti.",
      compatible: "Mezzi compatibili", infoNeeded: "Cosa comunicarci",
    },
    aboutPage: {
      overline: "AZIENDA E FLOTTA", title: "MEZZI, ESPERIENZA E PERSONE SU CUI CONTARE.",
      historyTitle: "La nostra storia", methodTitle: "Il nostro metodo",
      historyText: "EMME SERVICE CAR nasce per offrire un servizio di soccorso stradale e trasporto veicoli affidabile in Olbia, Gallura e Costa Smeralda. [Anno di fondazione, esperienza e dati dell'azienda verranno inseriti qui con informazioni reali.]",
      methodText: "Comunicazione chiara, valutazione del mezzo necessario, fissaggio corretto e trasporto controllato fino alla destinazione. Prima dell'intervento condividiamo sempre le condizioni.",
      valuesTitle: "I nostri valori",
      values: ["Sicurezza", "Chiarezza", "Puntualità", "Rispetto", "Cura del mezzo"],
      dataTitle: "Dati aziendali",
      placeholders: [
        { k: "Anno di fondazione", v: "[ANNO DI FONDAZIONE]" },
        { k: "Numero mezzi", v: "[NUMERO MEZZI]" },
        { k: "Esperienza", v: "[ESPERIENZA]" },
        { k: "Certificazioni", v: "[CERTIFICAZIONI]" },
        { k: "Assicurazioni", v: "[ASSICURAZIONI]" },
      ],
    },
    mobility: {
      overline: "ANCHE MOBILITÀ",
      title: "NON SOLO SOCCORSO STRADALE.",
      subtitle: "EMME SERVICE CAR è anche mobilità.",
      text: "Auto a noleggio e veicoli disponibili per la vendita: soluzioni per chi ha bisogno di ripartire o sta cercando la sua prossima auto.",
      rentTitle: "Noleggio Auto",
      rentText: "Soluzioni di noleggio auto per esigenze temporanee e di mobilità.",
      rentCta: "SCOPRI LE AUTO A NOLEGGIO",
      saleTitle: "Vendita veicoli commerciali",
      saleText: "Scopri i veicoli commerciali disponibili per la vendita.",
      saleCta: "VEDI I VEICOLI DISPONIBILI",
      soon: "Sezione in allestimento. Contattaci per informazioni e disponibilità.",
      backServices: "Torna ai servizi",
    },
    marquee: "SOCCORSO STRADALE 24/7 • TRASPORTO VEICOLI • RECUPERO AUTO E MOTO • ASSISTENZA PREMIUM • OLBIA · GALLURA · SARDEGNA",
    locationError: "Non siamo riusciti a rilevare la tua posizione. Puoi aprire WhatsApp e inviarcela manualmente.",
    whatsappNotice: "Stai per aprire WhatsApp con i dati dell'intervento.",
    breadcrumbHome: "Home",
    notFound: { title: "PAGINA NON TROVATA", text: "La pagina che cerchi non esiste o è stata spostata.", back: "TORNA ALLA HOME" },
  },

  en: {
    lang: "en",
    nav: { home: "Home", services: "Services", company: "Company & fleet", contact: "Contact", assistNow: "GET HELP NOW" },
    common: {
      callNow: "CALL NOW", call: "CALL", callFull: "CALL NOW", whatsapp: "MESSAGE US ON WHATSAPP",
      whatsappShort: "WHATSAPP", sendLocation: "SEND MY LOCATION", location: "LOCATION",
      requestQuote: "REQUEST A QUOTE", requestTransport: "REQUEST TRANSPORT", discover: "VIEW SERVICE",
      operativeNow: "Available now", callEmme: "CALL EMME SERVICE CAR", checkAvailability: "CHECK AVAILABILITY",
      readAllReviews: "Read reviews on Google", next: "Next", back: "Back", send: "Send request",
    },
    hero: {
      overline: "ROADSIDE ASSISTANCE & VEHICLE TRANSPORT",
      titleL1: "WHEN YOU STOP,", titleL2: "WE GET MOVING.",
      subtitle: "Roadside assistance and flatbed transport of cars, motorcycles, campers, agricultural and special vehicles.",
      question: "WHAT DO YOU NEED?",
      optNow: "I NEED HELP NOW", optSchedule: "I NEED TO SCHEDULE A TRANSPORT",
      nowHint: "Share your location, vehicle type and the issue.",
      scheduleHint: "We help you schedule a transport with a clear quote.",
    },
    trust: {
      title: "WHY CHOOSE EMME SERVICE CAR",
      items: [
        { t: "Professional assistance", d: "Trained operators and clear communication at every step." },
        { t: "Insured transport", d: "Insurance coverage of the vehicle during transport on the truck, per the policy conditions." },
        { t: "Trucks for every transport", d: "Configurations suited to different vehicle types." },
        { t: "Local & long distance", d: "Short moves and long hauls to the agreed destination." },
      ],
    },
    services: { overline: "WHAT WE DO", title: "HOW WE CAN HELP", subtitle: "One company for recovery, roadside assistance and transport of any vehicle." },
    timeline: {
      overline: "THE METHOD", title: "FROM THE CALL TO RECOVERY",
      steps: [
        { n: "01", t: "YOU CONTACT US", d: "Call us or send your location and details on WhatsApp." },
        { n: "02", t: "WE ASSESS THE JOB", d: "We identify vehicle, issue, location and the right truck." },
        { n: "03", t: "WE REACH YOU", d: "We keep you updated and reach the agreed point." },
        { n: "04", t: "WE RECOVER & TRANSPORT", d: "We secure the vehicle and transport it to the agreed destination." },
      ],
    },
    fleet: {
      overline: "THE FLEET", title: "THE RIGHT TRUCK FOR EVERY TRANSPORT",
      subtitle: "Real photos of the EMME SERVICE CAR fleet will go here. Clearly replaceable placeholders.",
      cards: [
        { t: "Sports Car Roadside Assistance", d: "Flatbed configuration for full and secure loading of the vehicle.", use: "Sports cars and premium vehicles" },
        { t: "Recovery For Heavy Transport", d: "For agricultural and work machinery.", use: "Tractors, excavators, equipment" },
      ],
      note: "Load capacity, dimensions and configurations will be shown only when verified.",
    },
    human: {
      titleL1: "WE DON'T JUST TRANSPORT,", titleL2: "WE TAKE CARE OF YOUR VEHICLE!",
      text: "A breakdown or an accident can be stressful. That is why we work with clear communication, care for the vehicle and respect for the customer.",
    },
    quote: {
      overline: "ONLINE QUOTE", title: "SCHEDULE YOUR TRANSPORT",
      subtitle: "A few steps. No account. We get back to you with conditions.",
      s1: "What do we need to transport?", s2: "From where to where?", s3: "When?", s4: "How can we reach you?",
      vehicles: ["Car", "Motorcycle", "Camper or caravan", "Agricultural tractor", "Work machine", "Other"],
      origin: "Pickup location", destination: "Destination",
      timings: ["First available date", "Specific date", "Urgent"],
      name: "Name", phone: "Phone", emailOpt: "Email (optional)", notes: "Notes",
      condition: "Vehicle condition", canLoad: "Can you load it yourself?",
      yes: "Yes", no: "No", summary: "Request summary",
      privacy: "I have read and accept the privacy policy.",
      openWhatsapp: "Open summary on WhatsApp",
      note: "The final quote depends on route, vehicle, loading conditions and the required truck.",
      success: "Request received. We will contact you using the details provided.",
      errPhone: "Please enter a number where we can reach you.",
      errRequired: "Please fill the required fields to continue.",
      errPrivacy: "You must accept the privacy policy to send the request.",
    },
    reviews: {
      overline: "REVIEWS", title: "TRUST IS BUILT ON THE ROAD.",
      placeholder: "Real Google reviews will appear here once the verified Google Business profile is connected. We do not publish fake reviews.",
    },
    map: {
      overline: "SERVICE AREA", title: "WHERE WE OPERATE",
      subtitle: "We operate across Olbia, Gallura and Costa Smeralda, with scheduled transport throughout Sardinia and nationwide.",
      hq: "Operational base",
    },
    faq: {
      overline: "FAQ", title: "WHAT YOU NEED TO KNOW",
      items: [
        { q: "Which vehicles can you transport?", a: "Cars, motorcycles, campers and caravans, tractors, excavators, work machinery and special vehicles, based on our trucks' capacity." },
        { q: "Do you offer urgent roadside assistance?", a: "Yes. You can call us directly or send your location on WhatsApp for a fast response." },
        { q: "Can I send my location directly?", a: "Yes. With the 'Send my location' button you share your GPS coordinates via WhatsApp in seconds." },
        { q: "Do you do long-distance transport?", a: "Yes, we organise scheduled transfers to regional and national destinations." },
        { q: "Do you transport motorcycles?", a: "Yes, with proper tie-down systems for safe transport of motorcycles and scooters." },
        { q: "Do you transport campers and caravans?", a: "Yes, we handle transfer and assistance of motorhomes, campers and caravans." },
        { q: "Can you transport tractors or work machinery?", a: "Yes, compatible with the load capacity and dimensions of our trucks." },
        { q: "How is the quote calculated?", a: "It depends on route, vehicle type, loading conditions and the required truck. We share conditions before the job." },
        { q: "Can I request a scheduled transport?", a: "Yes, through the online quote form or by contacting us directly." },
        { q: "Do you collect end-of-life vehicles for scrapping?", a: "Yes, we collect the vehicle and handle it according to the applicable procedures." },
        { q: "What information should I give during the call?", a: "Location, vehicle type, issue, destination and whether people or animals are on board." },
        { q: "Can I contact you via WhatsApp?", a: "Of course. WhatsApp is the fastest way to send us location, photos and details." },
      ],
    },
    finalCta: {
      titleL1: "STRANDED?", titleL2: "DON'T WASTE TIME SEARCHING.",
      text: "Call us or send your location. We'll tell you right away what we need to organise the job.",
      note: "For scheduled transport you can request a quote online.",
    },
    footer: {
      desc: "EMME SERVICE CAR provides roadside assistance, recovery and vehicle transport for private customers, companies and professionals.",
      contacts: "Contacts", pages: "Pages", area: "Service area", hours: "Hours",
      privacy: "Privacy Policy", cookie: "Cookie Policy", rights: "All rights reserved.",
    },
    contact: {
      overline: "CONTACT", title: "TALK TO EMME SERVICE CAR",
      prepareTitle: "When you contact us, have this ready:",
      prepare: ["Location", "Vehicle type", "Issue", "Destination", "People or animals on board"],
      phone: "Phone", email: "Email", address: "Address", hours: "Hours", area: "Service area",
    },
    servicesPage: {
      overline: "OUR SERVICES", title: "ASSISTANCE, RECOVERY & TRANSPORT",
      subtitle: "Six clear services for private customers, companies and professionals.",
      compatible: "Compatible trucks", infoNeeded: "What to tell us",
    },
    aboutPage: {
      overline: "COMPANY & FLEET", title: "TRUCKS, EXPERIENCE AND PEOPLE YOU CAN COUNT ON.",
      historyTitle: "Our story", methodTitle: "Our method",
      historyText: "EMME SERVICE CAR was founded to offer reliable roadside assistance and vehicle transport across Olbia, Gallura and Costa Smeralda. [Founding year, experience and company data will be added here with real information.]",
      methodText: "Clear communication, assessment of the right truck, correct securing and controlled transport to destination. We always share conditions before the job.",
      valuesTitle: "Our values",
      values: ["Safety", "Clarity", "Punctuality", "Respect", "Care of the vehicle"],
      dataTitle: "Company data",
      placeholders: [
        { k: "Founding year", v: "[FOUNDING YEAR]" },
        { k: "Number of trucks", v: "[NUMBER OF TRUCKS]" },
        { k: "Experience", v: "[EXPERIENCE]" },
        { k: "Certifications", v: "[CERTIFICATIONS]" },
        { k: "Insurance", v: "[INSURANCE]" },
      ],
    },
    mobility: {
      overline: "ALSO MOBILITY",
      title: "NOT JUST ROADSIDE ASSISTANCE.",
      subtitle: "EMME SERVICE CAR is mobility too.",
      text: "Rental cars and vehicles available for sale: solutions for those who need to get moving again or are looking for their next car.",
      rentTitle: "Car Rental",
      rentText: "Car rental solutions for temporary and mobility needs.",
      rentCta: "EXPLORE RENTAL CARS",
      saleTitle: "Commercial vehicles for sale",
      saleText: "Discover our commercial vehicles available for purchase.",
      saleCta: "VIEW AVAILABLE VEHICLES",
      soon: "Section coming soon. Contact us for information and availability.",
      backServices: "Back to services",
    },
    marquee: "24/7 ROADSIDE ASSISTANCE • VEHICLE TRANSPORT • CAR & MOTO RECOVERY • PREMIUM SERVICE • OLBIA · GALLURA · SARDINIA",
    locationError: "We couldn't detect your location. You can open WhatsApp and send it to us manually.",
    whatsappNotice: "You're about to open WhatsApp with the job details.",
    breadcrumbHome: "Home",
    notFound: { title: "PAGE NOT FOUND", text: "The page you are looking for doesn't exist or was moved.", back: "BACK TO HOME" },
  },
};
